var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.screenIndex===2?'slide-arrow cur':'slide-arrow',on:{"click":_vm.nextSection}},[_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }